module.exports = __webpack_public_path__ + "img/volleyball.c45ebec2.svg";